// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1kvJS","search":"Settings_search__2qqEv","filter":"Settings_filter__1mBTx"};